import { ErrorState } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../../components/Page/Page';

export const PageNotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <Page isForbidden={false} title={t('pageNotFound.title')}>
      <ErrorState
        onNavigateBack={() => {
          // no-op
        }}
        type='error'
      />
    </Page>
  );
};
